module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-group">\n    <label class="DescartesUILabel">' +
((__t = (labelText)) == null ? '' : __t) +
'</label>\n    <input name="title" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (value)) == null ? '' : __t) +
'">\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/AbstractEditGroup.ejs
// module id = 399
// module chunks = 0